<template>
  <div id="Zonghefenxi">
    <div class="tr-header">
      <p class="title">综合分析</p>
      <!-- <div class="handles" v-if="betType != 'xyrb' && betType != 'ks'">
        <span
          class="handle"
          @click="moreTable.double = !moreTable.double"
          :class="{'active':moreTable.double}"
        >今日双面/号码统计</span>
        <span
          class="handle"
          @click="moreTable.long = !moreTable.long"
          :class="{'active':moreTable.long}"
        >长龙提醒</span>
        <span
          class="handle"
          @click="moreTable.handle = !moreTable.handle"
          :class="{'active':moreTable.handle}"
        >号码分析</span>
      </div>-->
    </div>
    <!-- <div class="tr-header-container">
      <transition
        enter-active-class="animated fadeInLeft"
        leave-active-class="animated fadeOutLeft"
        mode="out-in"
      >
        <div class="handle-con" v-if="moreTable.double">
          <p class="title">今日双面统计</p>
          <Table stripe border :data="doubleStatis1" :columns="doubleStatisColumns1"></Table>
          <Table
            stripe
            border
            :data="doubleStatis2"
            :columns="doubleStatisColumns2"
            style="margin-top: 20px;"
          ></Table>
        </div>
      </transition>

      <transition
        enter-active-class="animated fadeInLeft"
        leave-active-class="animated fadeOutLeft"
        mode="out-in"
      >
        <div class="handle-con" v-if="moreTable.long">
          <p class="title">长龙连开提醒</p>
          <ul class="longQueue" v-if="longQueueContinue.length">
            <li v-for="(it,i) in longQueueContinue" :key="i">
              <span>{{it.name}}:</span>
              <span>{{it.type}}</span>
              <span :class="{'red':it.value >= 5}">{{it.value}}</span>
              <span>期</span>
            </li>
          </ul>
        </div>
      </transition>

      <transition
        enter-active-class="animated fadeInLeft"
        leave-active-class="animated fadeOutLeft"
        mode="out-in"
      >
        <div class="handle-con" v-if="moreTable.handle">
          <div class="title">
            <span>查看球号分布：</span>
            <div class="handles" style="display:inline-block;">
              <span
                class="handle"
                v-for="i in 10"
                v-if="betType == 'ssc'"
                :key="i"
                @click="handleSelectType(0,i-1)"
                :class="{'active':selectType === 0 && ~selectNumArr.indexOf(i-1)}"
              >号码{{i - 1}}</span>
              <span
                class="handle"
                v-for="i in 10"
                v-if="betType == 'PK10' || betType == 'nn'"
                :key="i"
                @click="handleSelectType(0,i)"
                :class="{'active':selectType === 0 && ~selectNumArr.indexOf(i)}"
              >号码{{i}}</span>
            </div>
          </div>
          <div class="title">
            <span>大小单双分布：</span>
            <div class="handles" style="display:inline-block;">
              <span
                class="handle"
                @click="handleSelectType(1,0)"
                :class="{'active':selectType === 1 && selectValue === 0}"
              >单</span>
              <span
                class="handle"
                @click="handleSelectType(1,1)"
                :class="{'active':selectType === 1 && selectValue === 1}"
              >双</span>
              <span
                class="handle"
                @click="handleSelectType(2,0)"
                :class="{'active':selectType === 2 && selectValue === 0}"
              >大</span>
              <span
                class="handle"
                @click="handleSelectType(2,1)"
                :class="{'active':selectType === 2 && selectValue === 1}"
              >小</span>
              <span
                class="handle"
                @click="handleSelectType(3,0)"
                :class="{'active':selectType === 3 && selectValue === 0}"
              >对子号</span>
              <span class="handle reset" @click="handleSelectType('','')">还原</span>
            </div>
          </div>
        </div>
      </transition>
    </div>-->
    <div class="tr-table-container">
      <Table :columns="columns" :loading="loading" :data="dataSource" stripe border></Table>
      <div class="page">
        <Page :total="total" :page-size="50" @on-change="handleMoreData" />
      </div>
    </div>
  </div>
</template>
<script>
import columns from "./columns";
import dayjs from "dayjs";

import statistic from "../../../helpers/statistic";

export default {
  name: "Zonghefenxi",
  data() {
    return {
      columns: [],
      dataSource: [],
      moreTable: {
        double: false,
        long: false,
        handle: false
      },
      pageSize: 50,
      startRow: 0,
      total: 0,
      loading: false,
      doubleStatisColumns1: [],
      doubleStatisColumns2: [],
      tableShowBallType: 0, // 0 显示号码 1 显示大小 2显示单双
      selectType: "", //0号码 1单双 2大小 3对子号
      selectNumArr: [], //0号码可以多选
      selectValue: "" //0-9    01    01     0
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    },

    doubleStatis1() {
      let obj = statistic.getDoubleDiscData(
        this.$route.params.betType,
        this.dataSource
      );
      obj["title"] = "出现次数";
      return [obj];
    },
    doubleStatis2() {
      let obj = statistic.getNumPattern(
        this.$route.params.betType,
        this.dataSource
      );
      obj["title"] = "出现次数";
      return [obj];
    },

    longQueueContinue() {
      return statistic.getLongQueueContinue(
        this.$route.params.betType,
        this.dataSource
      );
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.reset();
        this.init();
      }
    }
  },
  methods: {
    async handleMoreData(page) {
      this.loading = true;
      this.startRow = (page - 1) * 50;
      await this.init();
      this.loading = false;
    },
    reset() {
      // reset data
      this.columns = columns(this.betType).list(this);
      this.moreTable = {
        double: false,
        long: false,
        handle: false
      };
      this.tableShowBallType = 0;
      this.selectType = "";
      this.selectNumArr = [];
      this.selectValue = "";
      this.doubleStatisColumns1 = columns(this.betType).doubleStatisColumns1;
      // console.log("当前表格", this.doubleStatisColumns1);
      this.doubleStatisColumns2 = columns(this.betType).doubleStatisColumns2;
    },
    async init() {
      let res = await this.$http.post("/queryGameTypeResultByGameType.do", {
        gameType: this.$route.params.gameType,
        pageSize: this.pageSize,
        startRow: this.startRow,
        startDate: dayjs(new Date()).format("YYYYMMDD"),
        endDate: dayjs(new Date()).format("YYYYMMDD")
      });
      if (res.data.returnCode == "0000") {
        this.total = res.data.totalCount;
        this.dataSource = res.data.returnList;
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    },
    handleSelectType(type, value) {
      if (type === 0) {
        this.selectType = 0;
        this.selectValue = "";
        if (~this.selectNumArr.indexOf(value)) {
          this.selectNumArr.splice(this.selectNumArr.indexOf(value), 1);
          if (this.selectNumArr.length == 0) {
            this.selectType = "";
          }
        } else {
          this.selectNumArr.push(value);
        }
      } else {
        this.selectNumArr = [];
        if (this.selectValue === value && this.selectType === type) {
          this.selectValue = "";
          this.selectType = "";
        } else {
          this.selectType = type;
          this.selectValue = value;
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Zonghefenxi/index.vue